import { render } from "./WishlistItemInTheHeader.vue?vue&type=template&id=9e1a4746"
import script from "./WishlistItemInTheHeader.vue?vue&type=script&lang=js"
export * from "./WishlistItemInTheHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__